<!--
 * @Author: zhangjiangpo
 * @Date: 2024-07-02 15:49:18
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-25 19:57:46
 * @Description:
-->
<template>
  <div class="right-consume right-cicard">
    <div class="table-wrapper">
      <div class="table-filter">
        <div class="filter">
          <a-input
            placeholder="请输入助学师"
            style="width: 130px"
            class="filter-selection"
            allow-clear
            v-model="form.teacherName"
          />
          <a-input
            placeholder="请输入小组名称"
            style="width: 144px"
            class="filter-selection"
            allow-clear
            v-model="form.groupName"
          />
          <template>
            <span class="filter-selection">学年学期</span>
            <YearSemesterSelect ref="yearAndSemester" class="filter-selection" @updateYearAndSemester="updateYearAndSemester" />
          </template>
          <a-input
            placeholder="请输入学生姓名"
            style="width: 146px"
            class="filter-selection"
            allow-clear
            v-model="form.studentName"
          />
          <a-input
            placeholder="请输入学生手机号"
            style="width: 166px"
            class="filter-selection"
            allow-clear
            v-model="form.telephone"
            max-length="11"
          />
          <a-input
            placeholder="请输入课程名称"
            style="width: 166px"
            class="filter-selection"
            allow-clear
            v-model="form.courseName"
          />
          <template>
            <a-button type="primary" class="filter-selection" @click="doSearch">
              搜索
            </a-button>
          </template>
          <template>
            <a-button @click="doReset" class="ant-btn-secondary">
              重置
            </a-button>
          </template>
        </div>
        <div class="filter current-remain">
          <a-radio-group :value="form.auditStatus" @change="handleRightTypeChange" :options="CONSUME_INTERVIEW_STATUS" />
          <p>次卡剩余:{{ ciCardNum }}</p>
        </div>
      </div>
      <div class="list-box">
        <a-spin :spinning="spinning" tip="Loading..." :style="{width: '100%'}">
          <div class="group-list-box">
            <a-table
              :loading="loading"
              :columns="columns"
              :data-source="list"
              :pagination="false"
              row-key="_id"
              :scroll="scroll"
              :custom-row="customRow"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }"
            >
              <span slot="telephone" slot-scope="text, record">
                <div v-if="record._expanded" @click.stop="">
                  <p class="lesson-list" style="visibility: hidden;" v-for="item in record.lessonList" :key="item.lessonId"><a-button class="ant-btn-secondary" /></p>
                </div>
              </span>
              <!-- 当前名称 -->
              <span slot="studentName" slot-scope="text, record">
                <a-tooltip>
                  <template slot="title">
                    {{ text }}
                  </template>
                  <span style="height: 20px; overflow: hidden;">{{ text }}</span>
                </a-tooltip>
                <div v-if="record._expanded">
                  <p class="lesson-list" style="visibility: hidden;" v-for="item in record.lessonList" :key="item.lessonId"><a-button class="ant-btn-secondary" /></p>
                </div>
              </span>
              <span slot="groupName" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    {{ text }}
                  </template>
                  <span style="height: 20px; overflow: hidden;">{{ text }}</span>
                </a-tooltip>
              </span>
              <span slot="itvCourseName" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span style="height: 20px;" v-html="text" />
                  </template>
                  <span style="height: 20px; overflow: hidden;" v-html="text" />
                </a-tooltip>
              </span>
              <!-- 学年学期 -->
              <span slot="yearSemester" slot-scope="text, record">
                {{ record.year > 0 && record.semester ? (record.year + ' ' + record.semester) : '--' }}
              </span>
              <!-- 权益包类型 -->
              <span slot="lessonList" slot-scope="text, record">
                <div v-if="record._expanded" @click.stop="">
                  <p style="visibility: hidden;">占位</p>
                  <p class="lesson-list" style="visibility: hidden;" v-for="item in record.lessonList" :key="item.lessonId"><a-button class="ant-btn-secondary" /></p>
                  <div class="lesson-ope">
                    <p class="lesson-list" v-for="(item, index) in record.lessonList" :key="item.lessonId">
                      <!-- <span class="lesson-name">第{{ index + 1 }}讲 {{ item.lessonName }}</span> -->
                      <a-tooltip>
                        <template slot="title">
                          第{{ index + 1 }}讲 {{ item.lessonName }}
                        </template>
                        <span class="lesson-name" style="height: 20px; overflow: hidden;">第{{ item.lessonNum }}讲 {{ item.lessonName }}</span>
                      </a-tooltip>
                      <span>
                        <span>
                          <span v-if="item.auditStatus === AUDIT_STATUS.WAIT">
                            <span v-if="item.enableStatus === 1">
                              <a-button class="ant-btn-secondary" @click="handleApprove(record, item)" :disabled="notOneTwoType(record.cardType)" style="margin-right: 8px;">审核通过</a-button>
                              <a-button class="ant-btn-secondary" @click="handleReject(record, item)" :disabled="notOneTwoType(record.cardType)">审核不通过</a-button>
                              <Tip v-if="item.auditorName" :auditor-name="item.auditorName" :audit-time="item.auditTime" />
                            </span>
                            <span v-else>学生已不在组中，无需审核</span>
                          </span>
                          <span v-else-if="item.auditStatus === AUDIT_STATUS.APPROVE">
                            <span v-if="[18].includes(item.cardType)">审核通过</span>
                            <span v-else-if="[11, 12, 16, 17].includes(item.cardType)">一、二类权益，自动通过</span>
                            <!-- <span v-else-if="record.jurisdiction === JURISDICTION_TYPE.ALL_JUR">
                              小初全科权益，自动通过
                            </span> -->
                            <span v-else>小初全科权益，自动通过</span>
                            <Tip v-if="item.auditorName" :auditor-name="item.auditorName" :audit-time="item.auditTime" />
                          </span>
                          <span v-else>
                            审核不通过
                            <Tip v-if="item.auditorName" :auditor-name="item.auditorName" :audit-time="item.auditTime" />
                            <a-button v-if="item.enableStatus === 1" type="t-link" @click="handleReApprove(record, item)" :disabled="notOneTwoType(record.cardType)">重新审核</a-button>
                          </span>
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
                <div v-else><span :class="{ notClick: record._isCanNotClick }">查看</span></div>
              </span>
              <!-- 操作 -->
              <span slot="operation" slot-scope="text, record">
                {{ record._status }}
              </span>
            </a-table>
            <div class="pagination">
              <a-pagination
                v-show="pagination.total > 0"
                v-model="pagination.current"
                :total="pagination.total"
                :page-size="pagination.pageSize"
                :disabled="selectedRowKeys.length > 0"
                @change="handleChangePageNum"
              />
            </div>
            <div v-if="selectedRowKeys.length > 0" class="batch-approval">
              <div class="ba-content">
                <span>将消耗 {{ selectedNum() }} 个次卡</span>
                <a-button type="primary" @click="handleApproveBatch">
                  批量通过
                </a-button>
                <a-button @click="handleRejectBatch">
                  批量不通过
                </a-button>
              </div>
            </div>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import YearSemesterSelect from '@/components/YearSemesterSelect.vue'
import { CONSUME_INTERVIEW_STATUS, JURISDICTION_TYPE, RIGHT_PACKAGE_TYPE, AUDIT_STATUS, UPD_STATUS, SENIOR_CARD_TYPES } from '../constants.js'
import filters from '@/filters'
import { columns } from './columns'
import Tip from './tip'
import othersLog from '@/utils/logger/others.js'
import { debounce } from 'lodash'

export default {
  components: {
    YearSemesterSelect,
    Tip
  },
  data() {
    this.filters = filters
    return {
      CONSUME_INTERVIEW_STATUS,
      RIGHT_PACKAGE_TYPE,
      JURISDICTION_TYPE,
      SENIOR_CARD_TYPES,
      AUDIT_STATUS,
      scroll: { x: true, y: 'calc(100vh - 400px)' },
      loading: false,
      form: {
        teacherName: '',
        groupName: '',
        year: '',
        semester: '',
        studentName: '',
        telephone: '',
        auditStatus: -1,
        courseName: ''
      },
      ciCardNum: 0,
      pagination: {
        pageSize: 20,
        current: 1
      },
      columns,
      list: [],
      selectedRowKeys: [],
      spinning: false,
      cardTypesData: []
    }
  },
  created() {
    // 获取列表数据
    this.getList()
    othersLog.initPageLogger()
  },
  methods: {
    getCourseName(record) {
      return this.list.find(l => l._id === record._id)?.itvCourseName
    },
    customRow(record) {
      return {
        on: {
          click: () => {
            if (record._isCanNotClick) return
            record._expanded = !record._expanded
            this.list.splice(this.list.findIndex(l => l._id === record._id), 1, record)
          }
        }
      }
    },
    selectedNum() {
      var rnum = 0
      this.list.filter(l => this.selectedRowKeys.includes(l._id)).forEach(l => {
        const num = (l.lessonList || []).filter(ll => ll.auditStatus == AUDIT_STATUS.WAIT).length
        rnum += num
      })
      return rnum
    },
    async getRemainCount() {
      const reaminList = await this.$service.studentRight.insQuota({ cardType: [18] })
      return reaminList
    },
    isCanNotClick(list = []) {
      return list.findIndex(l => l.enableStatus != 1) > -1 && list.every(l => l.auditStatus == 0)
    },
    getRecordStatus(list = [], record = {}) {
      const statusArr = {
        0: 0,
        1: 0,
        2: 0
      }
      list.forEach(l => ++statusArr[l.auditStatus])
      const enableStatus = list.findIndex(l => l.enableStatus != 1) > -1
      if (enableStatus) {
        const ss = statusArr[2] + statusArr[1]
        return `学员已不在组中，无需审核` + (ss > 0 ? `，${ss}条已审核` : '')
      }
      if (statusArr[0] > 0) {
        return `${statusArr[0]}条未审核`
      }

      if (statusArr[2] > 0 && statusArr[1] > 0) {
        return `${statusArr[2]}条未通过`
      }
      if (statusArr[0] === 0 && statusArr[2] === 0 && statusArr[1] === 0) {
        return '无需审核'
      }
      if (statusArr[2] > 0) {
        return '审核不通过'
      }
      // return record.jurisdiction === JURISDICTION_TYPE.ALL_JUR ? '小初全科权益，自动通过' : [11, 12, 16, 17].includes(list[0].cardType) ? '一、二类权益，自动通过' : '审核通过'
      return [18].includes(list[0].cardType) ? '审核通过' : [11, 12, 16, 17].includes(list[0].cardType) ? '一、二类权益，自动通过' : '小初全科权益，自动通过'
    },
    async getList(resetSelectedRowKeys = true) {
      try {
        resetSelectedRowKeys && (this.selectedRowKeys = [])
        this.loading = true
        const result = await this.$service.studentRight.getCiCardList({ // getList getCiCardList
          ...this.form,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        })
        this.list = (result.list || []).map((r, index) => ({
          ...r,
          itvCourseName: (r.itvCourseName?.replaceAll && r.itvCourseName?.replaceAll(' ', '&nbsp;')) || r.itvCourseName,
          _id: r.userId + '_' + r.classTypeId + '_' + index,
          _expanded: false,
          _isCanNotClick: false, // this.isCanNotClick(r.lessonList),
          _status: this.getRecordStatus(r.lessonList, r)
          // cardType: 18
          // lessonList: [{
          //   lessonId: 123, lessonName: 'asdf1', auditStatus: 0
          // }, {
          //   lessonId: 124, lessonName: 'asdf2', auditStatus: 0
          // }, {
          //   lessonId: 125, lessonName: 'asdf3', auditStatus: 0
          // }]
        }))
        this.selectedRowKeys.length && this.list.forEach(l => {
          if (this.selectedRowKeys.includes(l._id)) {
            const p = this.getCheckboxProps(l)
            if (p.props && p.props.disabled) {
              this.selectedRowKeys.splice(this.selectedRowKeys.indexOf(l._id), 1)
            }
          }
        })
        this.pagination.total = result.itemTotal
        this.loading = false
      } catch (e) {
        this.loading = false
      }
      this.getInsQuota()
    },
    getInsQuota() {
      this.$service.studentRight.insQuota({ cardType: [18] }).then(res => {
        this.ciCardNum = (res && res.length && res[0].residueNumber) || 0
      })
    },
    handleRightTypeChange({ target: { value } }) {
      this.form.auditStatus = value
      this.pagination.current = 1
      // this.$refs.cardTypes.getData()
      this.getList()
    },
    updateYearAndSemester(opts) {
      this.form.year = opts.year === '全部' ? '' : opts.year
      this.form.semester = opts.semester === '全部' ? '' : opts.semester
    },
    doSearch() {
      this.pagination.current = 1
      // this.$refs.cardTypes.getData()
      this.getList()
    },
    doReset() {
      Object.keys(this.form).forEach(item => {
        this.form[item] = item === 'auditStatus' ? -1 : ''
      })
      this.$refs.yearAndSemester.clearSelect()
      this.pagination.current = 1
      this.$nextTick(() => {
        // this.$refs.cardTypes.getData()
        this.getList()
      })
    },
    handleChangePageNum(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    },
    handleApprove: debounce(async function(record, item) {
      return new Promise(resolve => {
        this.aduit(record, UPD_STATUS.APPROVE, resolve, item)
      })
    }, 500, { leading: false }),
    handleReject(record, item) {
      return new Promise(resolve => {
        this.aduit(record, UPD_STATUS.NOTAPPROVE, resolve, item)
      })
      // const typeName = RIGHT_PACKAGE_TYPE[record.cardType]
      // this.$confirm({
      //   title: '',
      //   content: h => <div>
      //                   <p>确认该学生审核不通过吗？</p>
      //                   <p>审核不通过，不会占用机构的{typeName}权益包名额</p>
      //                 </div>,
      //   onOk: () =>
      //     new Promise(resolve => {
      //       this.aduit(record, UPD_STATUS.NOTAPPROVE, resolve, item)
      //     })
      // })
    },
    async handleReApprove(record, item) {
      await this.aduit(record, UPD_STATUS.REAUDIT, () => {}, item)
    },
    async aduit(record, auditStatus, resolve, item) {
      const { userId, cardType, classTypeId } = record
      const { id } = item
      try {
        await this.$service.studentRight.rightApproval({
          id,
          userId,
          cardType,
          auditStatus,
          classTypeId
        }).then(res => {
          if (res) {
            const index = this.list.findIndex(l => l._id === record._id)
            if (index > -1) {
              const lessonList = this.list[index].lessonList?.map(le => {
                if (le.id === item.id) {
                  le.auditStatus = auditStatus
                }
                return { ...le }
              })
              this.list.splice(index, 1, {
                ...this.list[index],
                _isCanNotClick: false, // this.isCanNotClick(lessonList),
                _status: this.getRecordStatus(lessonList, this.list[index]),
                lessonList
              })
            }
            this.getInsQuota()
          }
        })
        othersLog.audit({
          id,
          userId,
          cardType,
          auditStatus,
          classTypeId
        })
        resolve()
        // this.getList()
        // this.$refs.cardTypes.getData()
      } catch (e) {
        console.log(e)
        resolve()
      }
    },
    getRemainDays (endTime) {
      const diff = endTime - new Date().getTime()
      const remainDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
      return `${remainDays > 14 ? 14 : remainDays}天`
    },
    getRightType(cardType) {
      return [11, 12, 16, 17, 18].indexOf(cardType) !== -1 ? RIGHT_PACKAGE_TYPE[cardType] : '--'
    },
    notOneTwoType(cardType) {
      return [11, 12, 16, 17, 18].indexOf(cardType) === -1
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: !record.lessonList || record.lessonList.every(r => r.auditStatus !== AUDIT_STATUS.WAIT) || record.lessonList.every(r => r.enableStatus !== 1) || this.notOneTwoType(record.cardType)
        }
      }
    },
    handleBatch: debounce(async function(isPass) {
      const selectedRow = this.list.filter(item => this.selectedRowKeys.includes(item._id))
      // 前端不校验了 后端处理讲次维度+校验
      // if (isPass) {
      //   const checkBatchData = selectedRow.reduce((prev, cur) => {
      //     prev[cur.cardType] = prev[cur.cardType] ? prev[cur.cardType] + 1 : 1
      //     return prev
      //   }, {})
      //   if (this.cardTypesData.findIndex(c => c.residueNumber < checkBatchData[c.cardType]) > -1) {
      //     this.$message.warn('剩余权益不足，请检查后重试')
      //     return
      //   }
      // }
      const param = selectedRow.map(item => ({
        studentUserId: item.userId,
        cardType: item.cardType,
        classTypeId: item.classTypeId,
        studentCourseId: item.id
      }))
      this.spinning = true
      const fn = isPass ? this.$service.studentRight.batchPass : this.$service.studentRight.batchReject
      fn(param).then(res => {
        this.$message.success(isPass ? '批量通过处理成功！' : '批量不通过处理成功！')
        this.getList()
        // this.$refs.cardTypes.getData()
      }, res => {
        if (Array.isArray(res.body)) {
          this.selectedRowKeys = res.body
        }
        this.getList(false)
        // this.$refs.cardTypes.getData()
      }).finally(() => {
        this.spinning = false
        othersLog.batchAudit({
          ...param,
          isPass
        })
      })
    }, 500, { leading: false }),
    handleApproveBatch() {
      this.handleBatch(TextTrackCueList)
    },
    handleRejectBatch() {
      this.handleBatch(false)
    },
    cardTypesChange(data) {
      this.cardTypesData = data
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/static/css/base.less';
:deep(.ant-table-fixed-right) {
  .ant-table-body-outer {
    margin-bottom: -6px !important;
  }
}
.right-consume {
  // 解决固定列底部预留的空隙
  :deep(.ant-table-fixed-left) {
    height: -webkit-fill-available;
    .ant-table-body-outer {
      margin-bottom: -6px !important;
      // &::-webkit-scrollbar {
      //   display: none !important;
      // }
    }
  }
}
.right-consume {
  .filter-selection {
    margin-right: 8px;
  }
  .table-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
    overflow: hidden;
    background: @gray-10;

    .table-filter {
      margin-bottom: 16px;
      .filter-title {
        margin-right: 12px;
      }

      .filter-title:not(:first-child) {
        margin-left: 20px;
      }

      .current-remain {
        display: flex;
        justify-content: space-between;
        margin-top:10px;
        padding-right:12px;
      }
      .approve-info {
        padding: 0 4px;
      }
    }
    .list-box {
      flex: 1;
      display: flex;
      flex-direction: row;
      overflow: hidden;
      .group-list-box {
        flex: 1;
        flex-direction: column;
        overflow: hidden;
        height: 100%;
        padding-right: 10px;
        position: relative;
        .table {
          flex: 1;
          overflow: auto;
        }
        .pagination {
          text-align: right;
          padding-top: 12px;
        }
        .batch-approval {
          position: absolute;
          top: 40px;
          right: 10px;
          width: 277px;
          height: calc(100% - 85px);
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99;
          border-left: 1px solid @gray-6;
          border-right: 1px solid @gray-6;
          .ba-content {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .ant-btn-primary {
              margin: 20px 0 15px 0;
              width: 112px;
            }
          }
        }
      }
    }
  }

  .red-color {
    color: red;
  }
}
.lesson-ope {
  width: 585px;
  background-color: #fff;
  padding: 18px 0;
  top: 0;
  right: 0;
  position: absolute;
  z-index: 90;
}
.lesson-list {
  height: 48px;
  padding: 7px 0;
}
.lesson-name {
  display: inline-block;
  width: 300px;
}
.notClick {
  color: #ccc;
}
</style>
<style>
tr {
  position: relative;
  cursor: pointer;
}
.right-cicard {
  .ant-table-row-hover .lesson-ope {
    background-color: rgb(245, 247, 249);
  }
  .ant-table-row.ant-table-row-hover.ant-table-row-level-0 {
    .ant-table-row-cell-break-word {
    }
  }
}
</style>
